import './instagramFeed.css';

import Instafeed from 'instafeed.js';
import React, { useEffect } from 'react';

import { Box, Flex } from '../Core';
import SectionWithTitle from '../SectionWithTitle';

interface IInstagramFeedProps {
  heading?: string | null;
  text?: string | null;
  account: 'kine' | 'institute';
}

const InstagramFeed: FCWithClassName<IInstagramFeedProps> = (props) => {
  const tokens = {
    institute: process.env.GATSBY_INSTATOKEN_SECRET_INSTITUTE,
    kine: process.env.GATSBY_INSTATOKEN_SECRET_KINE,
  };
  useEffect(() => {
    const initializeInstafeed = () => {
      const accessToken = tokens[props.account];
      if (typeof accessToken !== 'string') return;
      const feed = new Instafeed({
        accessToken,
        limit: 6,
        template:
          '<a href="{{link}}" class="border-b-0" target="_blank" rel="noopener"><img title="{{caption}}" lazyload src="{{image}}" /></a>',
      });
      feed.run();
    };
    initializeInstafeed();
  }, []);
  return (
    <SectionWithTitle
      heading={props.heading}
      text={props.text}
      className="max-w-screen-xl mx-auto instagram-section my-gap"
    >
      <Box className="relative w-full">
        <Flex
          id="instafeed"
          className="flex-wrap effectLink effectImg"
          justify="center"
        />
      </Box>
    </SectionWithTitle>
  );
};

export default InstagramFeed;
